import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HeaderTitle } from "@app/shared/common/header-title/header-title.model";
import { HeaderTitleService } from "@app/shared/common/header-title/header-title.service";
import { BreadcrumbItem } from "@app/shared/common/sub-header/sub-header.component";
import { appModuleAnimation } from "@shared/animations/routerTransition";


@Component({
    templateUrl: 'help-menu.component.html',
    selector: 'help-menu',
    animations: [appModuleAnimation()]
})
export class HelpMenuComponent implements OnInit {
    @Input() isDropup = false;
    demoShow: boolean;
    ngOnInit(): void {
        this.demoShow = false;
       /* this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem('Help Section')
        ]));*/
        //throw new Error("Method not implemented.");

    }
    constructor(private router: Router,
        private headerTitleService: HeaderTitleService,){

    }
    // getHelpSection() {
    //     this.router.navigate(['/app/main/CommonUiElements/help_section']);
    // }

    getHelpSection() {
     window.open('https://support.intimepro.io/support/tickets/new/', '_blank');
  }
}
